import { FC } from 'react';
import TemplatePreviewMain, { TemplatePreviewMainProps } from './main';
import { TemplatePreviewStoreProvider } from './store';

export const TemplatePreviewWrapper: FC<TemplatePreviewMainProps> = ({ children, ...mainProps }) => {
  return (
    <TemplatePreviewStoreProvider>
      <TemplatePreviewMain {...mainProps}>{children}</TemplatePreviewMain>
    </TemplatePreviewStoreProvider>
  );
};
